<template>
  <div>
    <div
      style="
        display: flex;
        flex-flow: row wrap;
        align-content: flex-start;
        background: #fdfdfd;
      "
    >
      <div
        class="card-body"
        v-for="(card, index) in cards"
        :key="index"
        @click="toDetail(card)"
      >
        <div class="edittool" v-if="editStatus">
          <div class="radio-position" @click.stop="selectRadio(card)">
            <img
              v-if="!card.showSelect"
              style="width: 20px; height: 20px"
              src="@/assets/select.png"
            />
            <img
              v-if="card.showSelect"
              style="width: 20px; height: 20px"
              src="@/assets/select-on.png"
            />
          </div>
          <div class="edit-status">
            <div
              @click.stop="edidProjectDetails(card)"
              class="edit-button edit-other"
            >
              编辑
            </div>
            <div @click.stop="deleteProject(card)" class="edit-button">
              删除
            </div>
          </div>
        </div>

        <div class="card-content">
          <p class="card-title">
            <img
              :src="card.headImg"
              alt=""
              style="width: 33px; height: 33px; margin-right: 14px"
            />
            <span>{{ card.departName }}</span>
          </p>
          <p class="card-desc">{{ card.description }}</p>
          <a-divider class="card-divider" />
          <div class="card-bottom">
            <div class="card-bottom-left">
              <span>
                团队人数:{{ card.memberNum }}/{{
                  card.accountMemberLimit
                }}</span
              >
            </div>
            <div class="card-bottom-right">
              <img
                :src="card.avatar || require('@/assets/avatar.png')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination">
      <a-pagination
      v-if="list_params"
        :current="list_params.pageNo"
        @change="pageChange"
        size="large"
        :total="total"
        :pageSize="list_params.pageSize"
        show-quick-jumper
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Department",
  data() {
    return {
      // card:[],
      headImg: require("@/assets/avatar.png"),
    };
  },
  props: {
    showSelect: {
      type: Boolean,
    },
    editStatus: {
      type: Boolean,
    },
    cards: {
      type: Array,
    },
    list_params: {
      type: Object,
    },
    total :{
      type: Number,
    }
  },
  watch: {
    cards(val) {
      let self = this;
      self.dealCardData(val);
    },
  },
  methods: {
    dealCardData(cards) {
      cards.forEach((card) => {
        card.projectLikeNum =
          card.projectLikeNum == "" || card.projectLikeNum == null
            ? 0
            : card.projectLikeNum;
        card.tagNames =
          card.tagNames == "" || card.tagNames == null
            ? ["暂无标签"]
            : _.compact(_.split(card.tagNames, ","));
      });
    },
    selectRadio(card) {
      this.$emit("selectRadio", card);
    },
    edidProjectDetails(card) {
      console.log("触发事件", card);
      this.$emit("edidProjectDetails", card);
    },
    deleteProject(card) {
      this.$emit("deleteProject", card.id);
    },
    toDetail(card) {
      this.$emit("toDetail", card.id);
    },
    pageChange(page){
      this.$emit("pageChange",page)
    }
  },
};
</script>

<style lang="less" scoped>
.card-body {
  position: relative;
  background-color: #fff;
  width: 323px;
  margin: 12px;
  cursor: pointer;
  display: inline-block;
  .card-head-img {
    height: 160px;
    img {
      height: 100%;
    }
  }
  .card-content {
    width: 283px;
    margin: 15px 20px 0 20px;
    .card-title {
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #333333;
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
    }
    .card-desc {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      text-align: justify;
      overflow: hidden;
      /*white-space: nowrap;*/
      /*text-overflow: ellipsis;*/
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .card-tag {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #999999;
      text-align: left;
    }
    .card-tag-arr {
      text-align: left;
      span {
        background: #f5f5f5;
        border-radius: 4px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #666666;
        padding: 5px 10px;
        margin: 0 5px;
      }
      span:first-child {
        margin-left: 0;
      }
    }
    .card-divider {
      height: 1px;
    }

    .card-bottom {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
      .card-bottom-left span {
        font-family: HelveticaNeue;
        font-size: 12px;
        color: #999999;
      }
      .card-bottom-right img {
        width: 26.6px;
        height: 26.6px;
        margin-left: -13px;
      }
    }
  }
}
.praiseText {
  cursor: pointer;
}
.Active {
  color: red !important;
}

.edittool {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1000;
  /* display: none; */
}

.pagination {
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.radio-position {
  position: absolute;
  top: 15px;
  right: 15px;
}

.edit-status {
  display: flex;
  width: 100%;
  position: absolute;
  line-height: 50px;
  bottom: 0;
  background-color: #ffffff;
}

.edit-button {
  width: 50%;
  text-align: center;
  box-sizing: border-box;
}

.edit-other {
  color: #fa493c;
  border-right: 1px #e8e8e8 solid;
}
</style>